/* ==========================================
   HOME STANDARD — PRODUCT CARD VARIANTS

   Thumbnail selection
   Product image switching
   Dynamic pricing
   Selected variant links
   Prevent unwanted product navigation
   ========================================== */

(() => {
  if (window.HSCardVariantsLoaded) return;

  window.HSCardVariantsLoaded = true;

  /* ==========================================
     VARIANT SELECTION
     ========================================== */

  function selectVariant(button) {

    const card = button.closest('[data-hs-card]');

    if (!card) return;

    /* UPDATE PRODUCT IMAGE */

    const mainImage = card.querySelector('[data-hs-main-image]');

    if (mainImage && button.dataset.image) {

      // Prevent the browser from using an outdated responsive image.
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');

      // Display the selected variant image.
      mainImage.src = button.dataset.image;
      mainImage.alt = button.dataset.imageAlt || '';

      // Prevent secondary hover images from covering it.
      card.classList.add('hs-variant-selected');

    }

    /* UPDATE SELECTED THUMBNAIL */

    card.querySelectorAll('[data-hs-variant]').forEach((item) => {

      const selected = item === button;

      item.classList.toggle('is-active', selected);

      item.setAttribute('aria-pressed', String(selected));

    });

    /* UPDATE PRODUCT LINKS */

    if (button.dataset.url) {

      card.querySelectorAll('[data-hs-product-link]').forEach((link) => {

        link.href = button.dataset.url;

      });

    }

    /* UPDATE PRODUCT PRICE */

    const price = card.querySelector('[data-hs-price]');

    if (price) {

      const current = price.querySelector('[data-hs-price-current]');

      const compare = price.querySelector('[data-hs-price-compare]');

      const discount = price.querySelector('[data-hs-price-discount]');

      if (current) {

        current.textContent = button.dataset.price || '';

      }

      if (compare) {

        compare.textContent = button.dataset.compare || '';

        compare.hidden = !button.dataset.compare;

      }

      if (discount) {

        discount.textContent = button.dataset.discount || '';

        discount.hidden = !button.dataset.discount;

      }

    }

  }

  /* ==========================================
     INTERCEPT THUMBNAIL CLICKS

     Capture phase runs before Shopify's
     normal bubbling click handlers.
     ========================================== */

  document.addEventListener('click', (event) => {

    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest('[data-hs-variant]');

    if (!button) return;

    const card = button.closest('[data-hs-card]');

    if (!card) return;

    // Prevent anchor navigation.
    event.preventDefault();

    // Prevent Shopify card click handlers.
    event.stopPropagation();
    event.stopImmediatePropagation();

    // Change the selected variant without navigating.
    selectVariant(button);

  }, true);

  /* ==========================================
     KEEP +N NAVIGATION WORKING

     +N must remain a normal product link.
     ========================================== */

  document.addEventListener('click', (event) => {

    const target = event.target;

    if (!(target instanceof Element)) return;

    const moreLink = target.closest('.hs-variant-more');

    if (!moreLink) return;

    // Allow the link to navigate normally.
    // Stop other card handlers from interfering.
    event.stopPropagation();

  }, true);

})();